import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { CoreCommonModule } from '@core/common.module';
import { ContentHeaderModule } from 'app/layout/components/content-header/content-header.module';
import { AuthenticationModule } from './authentication/authentication.module';
import { MiscellaneousModule } from './miscellaneous/miscellaneous.module';
import { DashboardComponent } from './dashboard/dashboard.component';
import { AddProductComponent } from './gestionProduits/add-product/add-product.component';
import { AddProductShellComponent } from './gestionProduits/add-product/add-product-shell.component';
import { ActiveProductsComponent } from './gestionProduits/active-products/active-products.component';
import { ArchivesProductsComponent } from './gestionProduits/archives-products/archives-products.component';
import { ProductTableComponent } from './gestionProduits/product-table/product-table.component';
import { ProductDetailShellComponent } from './gestionProduits/detail-product/product-detail-shell.component';
import { ProductsListShellComponent } from './gestionProduits/products-list-shell.component';
import { ClientsListShellComponent } from './clients/clients-list-shell.component';
import { LayoutStepsComponent } from './gestionProduits/layout-steps/layout-steps.component';
import { EtatStockComponent } from './stock/gestionStock/etat-stock/etat-stock.component';
import { EditProductComponent } from './gestionProduits/edit-product/edit-product.component';
import { GestionStockComponent } from './stock/gestionStock/gestion-stock.component';
import { ApercuComponent } from './stock/gestionStock/etat-stock/apercu/apercu.component';
import { EtatTableComponent } from './stock/gestionStock/etat-stock/etat-table/etat-table.component';
import { ResetStockComponent } from './stock/gestionStock/reset-stock/reset-stock.component';
import { InventaireComponent } from './stock/inventaire/inventaire.component';
import { EditWarehouseComponent } from './stock/gestionStock/edit-warehouse/edit-warehouse.component';
import { ProductsComponent } from './gestionProduits/products.component';
import { NavbarModule } from 'app/layout/components/navbar/navbar.module';
import { RouterModule } from '@angular/router';
import { NgxPaginationModule } from 'ngx-pagination';
import { AddInventaireComponent } from './stock/inventaire/add-inventaire/add-inventaire.component';
import { ApprovedInventaireComponent } from './stock/inventaire/approved-inventaire/approved-inventaire.component';
import { AllInvComponent } from './stock/inventaire/all-inv/all-inv.component';
import { ValideInvComponent } from './stock/inventaire/valide-inv/valide-inv.component';
import { CreateInvComponent } from './stock/inventaire/create-inv/create-inv.component';
import { CancelInvComponent } from './stock/inventaire/cancel-inv/cancel-inv.component';
import { BroullionInvComponent } from './stock/inventaire/broullion-inv/broullion-inv.component';
import { InventaireTableComponent } from './stock/inventaire/inventaire-table/inventaire-table.component';
import { BonTransfertComponent } from './stock/bon-transfert/bon-transfert/bon-transfert.component';
import { FournisseursListShellComponent } from './fournisseur/fournisseurs-list-shell.component';
import { AddClientComponent } from './clients/add-client/add-client.component';
import { AddClientShellComponent } from './clients/add-client/add-client-shell.component';
import { ClientDetailShellComponent } from './clients/details/client-detail-shell.component';
import { FournisseurDetailShellComponent } from './fournisseur/details-fourniss/fournisseur-detail-shell.component';
import { DetailsComponent } from './clients/details/details.component';
import { DetailsChiffreAffComponent } from './clients/details/details-chiffre-aff/details-chiffre-aff.component';
import { DetailsContenueComponent } from './clients/details/details-contenue/details-contenue.component';
import { DetailsFacturesComponent } from './clients/details/details-factures/details-factures.component';
import { DetailsProfilComponent } from './clients/details/details-profil/details-profil.component';


import { DetailsContenueReleveCompteComponent } from './clients/details/details-contenue/details-contenue-releve-compte/details-contenue-releve-compte.component';
import { DocumentBonDeLivraisonComponent } from './clients/details/details-contenue/details-contenue-document/document-bon-de-livraison/document-bon-de-livraison.component';
import { DocumentBonDeSoriteComponent } from './clients/details/details-contenue/details-contenue-document/document-bon-de-sorite/document-bon-de-sorite.component';
import { DocumentCommandeClientComponent } from './clients/details/details-contenue/details-contenue-document/document-commande-client/document-commande-client.component';
import { DocumentDevisComponent } from './clients/details/details-contenue/details-contenue-document/document-devis/document-devis.component';
import { DocumentFactureComponent } from './clients/details/details-contenue/details-contenue-document/document-facture/document-facture.component';
import { AddFournisseurComponent } from './fournisseur/add-fournisseur/add-fournisseur.component';
import { AddFournisseurShellComponent } from './fournisseur/add-fournisseur/add-fournisseur-shell.component';
import { DetailsFournissComponent } from './fournisseur/details-fourniss/details-fourniss.component';
import { FournissDetailChiffreAffComponent } from './fournisseur/details-fourniss/fourniss-detail-chiffre-aff/fourniss-detail-chiffre-aff.component';
import { FournissDetailChiffreContenueComponent } from './fournisseur/details-fourniss/fourniss-detail-chiffre-contenue-fr/fourniss-detail-chiffre-contenue.component';
import { FournissDetailProfilComponent } from './fournisseur/details-fourniss/fourniss-detail-profil/fourniss-detail-profil.component';
import { FournissDetailChiffreFactureComponent } from './fournisseur/details-fourniss/fourniss-detail-chiffre-facture-fr/fourniss-detail-chiffre-facture.component';
import { DevisComponent } from './Vente/devis/devis.component';
import { ApproveBarBonLivNegoceComponent } from './VenteNegoce/bon-livraison/approve-bar-bon-liv/approve-bar-bon-liv-negoce.component';
import { BonLivraisonNegoceComponent } from './VenteNegoce/bon-livraison/bon-livraison-negoce.component';
import { AnnuleBonLivNegoceComponent } from './VenteNegoce/bon-livraison/tabBonLiv/annule-bon-liv/annule-bon-liv-negoce.component';
import { BrouillonBonLivNegoceComponent } from './VenteNegoce/bon-livraison/tabBonLiv/brouillon-bon-liv/brouillon-bon-liv-negoce.component';
import { CreeBonLivNegoceComponent } from './VenteNegoce/bon-livraison/tabBonLiv/cree-bon-liv/cree-bon-liv-negoce.component';
import { LivreBonLivNegoceComponent } from './VenteNegoce/bon-livraison/tabBonLiv/livre-bon-liv/livre-bon-liv-negoce.component';
import { TousBonLivNegoceComponent } from './VenteNegoce/bon-livraison/tabBonLiv/tous-bon-liv/tous-bon-liv-negoce.component';
import { ApproveBonSortieNegoceComponent } from './VenteNegoce/bon-sortie/approve-bon-sortie/approve-bon-sortie-negoce.component';
import { BonSortieNegoceComponent } from './VenteNegoce/bon-sortie/bon-sortie-negoce.component';
import { AnnuleBonSortieNegoceComponent } from './VenteNegoce/bon-sortie/tabBonSortie/annule-bon-sortie/annule-bon-sortie-negoce.component';
import { BrouillonBonSortieNegoceComponent } from './VenteNegoce/bon-sortie/tabBonSortie/brouillon-bon-sortie/brouillon-bon-sortie-negoce.component';
import { CreeBonSortieNegoceComponent } from './VenteNegoce/bon-sortie/tabBonSortie/cree-bon-sortie/cree-bon-sortie-negoce.component';
import { FermeBonSortieNegoceComponent } from './VenteNegoce/bon-sortie/tabBonSortie/ferme-bon-sortie/ferme-bon-sortie-negoce.component';
import { TousBonSortieNegoceComponent } from './VenteNegoce/bon-sortie/tabBonSortie/tous-bon-sortie/tous-bon-sortie-negoce.component';
import { ApproveCmdNegoceComponent } from './VenteNegoce/commande-client/approve-cmd/approve-cmd-negoce.component';
import { CommandeClientNegoceComponent } from './VenteNegoce/commande-client/commande-client-negoce.component';
import { SmsModalNegoceComponent } from './VenteNegoce/commande-client/sms-modal/sms-modal-negoce.component';
import { TabCmdClientNegoceComponent } from './VenteNegoce/commande-client/tab-cmd-client/tab-cmd-client-negoce.component';
import { AnnuleCmdNegoceComponent } from './VenteNegoce/commande-client/tab-cmd/annule-cmd/annule-cmd-negoce.component';
import { BrouillonCmdNegoceComponent } from './VenteNegoce/commande-client/tab-cmd/brouillon-cmd/brouillon-cmd-negoce.component';
import { CreeCmdNegoceComponent } from './VenteNegoce/commande-client/tab-cmd/cree-cmd/cree-cmd-negoce.component';
import { TousCmdNegoceComponent } from './VenteNegoce/commande-client/tab-cmd/tous-cmd/tous-cmd-negoce.component';
import { ValideCmdNegoceComponent } from './VenteNegoce/commande-client/tab-cmd/valide-cmd/valide-cmd-negoce.component';
import { AccepterDevisNegoceComponent } from './VenteNegoce/devis/Tabs/accepter-devis/accepter-devis-negoce.component';
import { AnnulerDevisNegoceComponent } from './VenteNegoce/devis/Tabs/annuler-devis/annuler-devis-negoce.component';
import { BrouillonDevisNegoceComponent } from './VenteNegoce/devis/Tabs/brouillon-devis/brouillon-devis-negoce.component';
import { CreeDevisNegoceComponent } from './VenteNegoce/devis/Tabs/cree-devis/cree-devis-negoce.component';
import { NegociationDevisNegoceComponent } from './VenteNegoce/devis/Tabs/negociation-devis/negociation-devis-negoce.component';
import { TousDevisNegoceComponent } from './VenteNegoce/devis/Tabs/tous-devis/tous-devis-negoce.component';
import { ConvertModalNegoceComponent } from './VenteNegoce/devis/convert-modal/convert-modal-negoce.component';
import { DevisNegoceComponent } from './VenteNegoce/devis/devis-negoce.component';
import { DetailVenteNegoceComponent } from './VenteNegoce/devis/detail-vente/detail-vente-negoce.component';
import { EmailComposeNegoceComponent } from './VenteNegoce/devis/parametre-bar/email-compose/email-compose-negoce.component';
import { FileUploadModalNegoceComponent } from './VenteNegoce/devis/parametre-bar/file-upload-modal/file-upload-modal-negoce.component';
import { ImportQRNegoceComponent } from './VenteNegoce/devis/parametre-bar/import-qr/import-qr-negoce.component';
import { ParametreBarNegoceComponent } from './VenteNegoce/devis/parametre-bar/parametre-bar-negoce.component';
import { ApproveVenteComponent } from './Vente/devis/approve-vente/approve-vente.component';
import { ConvertModalComponent } from './Vente/devis/convert-modal/convert-modal.component';
import { DetailVenteComponent } from './Vente/devis/detail-vente/detail-vente.component';
import { ParametreBarComponent } from './Vente/devis/parametre-bar/parametre-bar.component';
import { SharedComponent } from './shared/shared.component';
import { DocumentListProgressComponent } from './shared/document-list-progress/document-list-progress.component';
import { TabCountComponent } from './shared/tab-count/tab-count.component';
import { TablePaginationBarComponent } from './shared/table-pagination-bar/table-pagination-bar.component';
import { TitleSectionComponent } from 'app/layout/components/navbar/title-section/title-section.component';
import { EmailComposeComponent } from './Vente/devis/parametre-bar/email-compose/email-compose.component';
import { FileUploadModalComponent } from './Vente/devis/parametre-bar/file-upload-modal/file-upload-modal.component';
import { ImportQRComponent } from './Vente/devis/parametre-bar/import-qr/import-qr.component';
import { LayoutStepFournissComponent } from './fournisseur/add-fournisseur/layout-step-fourniss/layout-step-fourniss.component';
import { LayoutStepsClientModule } from './clients/add-client/layout-steps-client/layout-steps-client.module';
import { FrDetailContenuApercueComponent } from './fournisseur/details-fourniss/fourniss-detail-contenue/fr-detail-contenu-apercue/fr-detail-contenu-apercue.component';
import { FrDetailContenuDocumentComponent } from './fournisseur/details-fourniss/fourniss-detail-contenue/fr-detail-contenu-document/fr-detail-contenu-document.component';
import { FrDetailContenuPaiementNonAffComponent } from './fournisseur/details-fourniss/fourniss-detail-contenue/fr-detail-contenu-paiement-non-aff/fr-detail-contenu-paiement-non-aff.component';
import { FrDetailContenuReleveCompteComponent } from './fournisseur/details-fourniss/fourniss-detail-contenue/fr-detail-contenu-releve-compte/fr-detail-contenu-releve-compte.component';
import {NgChartsModule} from 'ng2-charts';
import { FrDocBonRecepComponent } from './fournisseur/details-fourniss/fourniss-detail-contenue/fr-detail-contenu-document/fr-doc-bon-recep/fr-doc-bon-recep.component';
import { FrDocCommandeComponent } from './fournisseur/details-fourniss/fourniss-detail-contenue/fr-detail-contenu-document/fr-doc-commande/fr-doc-commande.component';
import { FrDocFactureComponent } from './fournisseur/details-fourniss/fourniss-detail-contenue/fr-detail-contenu-document/fr-doc-facture/fr-doc-facture.component';
import {FournissDetailContenueComponent} from './fournisseur/details-fourniss/fourniss-detail-contenue/fourniss-detail-contenue.component';
import {
    DetailsContenueApercueComponent
} from './clients/details/details-contenue/details-contenue-apercue/details-contenue-apercue.component';
import {
    DetailsContenueDocumentComponent
} from './clients/details/details-contenue/details-contenue-document/details-contenue-document.component';
import {
    DetailsContenuePaiementNonAffComponent
} from './clients/details/details-contenue/details-contenue-paiement-non-aff/details-contenue-paiement-non-aff.component';

import { BrouillonDevisComponent } from './Vente/devis/Tabs/brouillon-devis/brouillon-devis.component';
import { TousDevisComponent } from './Vente/devis/Tabs/tous-devis/tous-devis.component';
import { CreeDevisComponent } from './Vente/devis/Tabs/cree-devis/cree-devis.component';
import { AnnulerDevisComponent } from './Vente/devis/Tabs/annuler-devis/annuler-devis.component';
import { NegociationDevisComponent } from './Vente/devis/Tabs/negociation-devis/negociation-devis.component';
import { AccepterDevisComponent } from './Vente/devis/Tabs/accepter-devis/accepter-devis.component';
import { TresorerieComponent } from './comptabilite/tresorerie/tresorerie.component';
import { DetailTresorerieComponent } from './comptabilite/detail-tresorerie/detail-tresorerie.component';
import { SaveComponent } from './comptabilite/detail-tresorerie/save/save.component';
import { AddDepenseComponent } from './comptabilite/tresorerie/add-depense/add-depense.component';
import { AjoutSoldeComponent } from './comptabilite/tresorerie/ajout-solde/ajout-solde.component';
import { RemiseBanqueComponent } from './comptabilite/tresorerie/remise-banque/remise-banque.component';
import { CommandeClientComponent } from './Vente/commande-client/commande-client.component';
import { TabCmdClientComponent } from './Vente/commande-client/tab-cmd-client/tab-cmd-client.component';
import { ApproveCmdComponent } from './Vente/commande-client/approve-cmd/approve-cmd.component';
import { TousCmdComponent } from './Vente/commande-client/tab-cmd/tous-cmd/tous-cmd.component';
import { BrouillonCmdComponent } from './Vente/commande-client/tab-cmd/brouillon-cmd/brouillon-cmd.component';
import { AnnuleCmdComponent } from './Vente/commande-client/tab-cmd/annule-cmd/annule-cmd.component';
import { CreeCmdComponent } from './Vente/commande-client/tab-cmd/cree-cmd/cree-cmd.component';
import { ValideCmdComponent } from './Vente/commande-client/tab-cmd/valide-cmd/valide-cmd.component';
import { FactureComponent } from './Vente/facture/facture.component';
import { BonLivraisonComponent } from './Vente/bon-livraison/bon-livraison.component';
import { BonSortieComponent } from './Vente/bon-sortie/bon-sortie.component';
import { TousBonLivComponent } from './Vente/bon-livraison/tabBonLiv/tous-bon-liv/tous-bon-liv.component';
import { BrouillonBonLivComponent } from './Vente/bon-livraison/tabBonLiv/brouillon-bon-liv/brouillon-bon-liv.component';
import { CreeBonLivComponent } from './Vente/bon-livraison/tabBonLiv/cree-bon-liv/cree-bon-liv.component';
import { AnnuleBonLivComponent } from './Vente/bon-livraison/tabBonLiv/annule-bon-liv/annule-bon-liv.component';
import { LivreBonLivComponent } from './Vente/bon-livraison/tabBonLiv/livre-bon-liv/livre-bon-liv.component';
import { ApproveBarBonLivComponent } from './Vente/bon-livraison/approve-bar-bon-liv/approve-bar-bon-liv.component';
import { TousFactureComponent } from './Vente/facture/tabFacture/tous-facture/tous-facture.component';
import { BrouillonFactureComponent } from './Vente/facture/tabFacture/brouillon-facture/brouillon-facture.component';
import { PayeFactureComponent } from './Vente/facture/tabFacture/paye-facture/paye-facture.component';
import { AnnuleFactureComponent } from './Vente/facture/tabFacture/annule-facture/annule-facture.component';
import { NonPayeFactureComponent } from './Vente/facture/tabFacture/non-paye-facture/non-paye-facture.component';
import { ApproveFactureComponent } from './Vente/facture/approve-facture/approve-facture.component';
import { ApproveBonSortieComponent } from './Vente/bon-sortie/approve-bon-sortie/approve-bon-sortie.component';
import { TousBonSortieComponent } from './Vente/bon-sortie/tabBonSortie/tous-bon-sortie/tous-bon-sortie.component';
import { BrouillonBonSortieComponent } from './Vente/bon-sortie/tabBonSortie/brouillon-bon-sortie/brouillon-bon-sortie.component';
import { CreeBonSortieComponent } from './Vente/bon-sortie/tabBonSortie/cree-bon-sortie/cree-bon-sortie.component';
import { AnnuleBonSortieComponent } from './Vente/bon-sortie/tabBonSortie/annule-bon-sortie/annule-bon-sortie.component';
import { FermeBonSortieComponent } from './Vente/bon-sortie/tabBonSortie/ferme-bon-sortie/ferme-bon-sortie.component';
import { PaiementFactureComponent } from './Vente/facture/paiement-facture/paiement-facture.component';
import { NouveauPaiementComponent } from './Vente/facture/paiement-facture/nouveau-paiement/nouveau-paiement.component';
import { PaiementNonAffComponent } from './Vente/facture/paiement-facture/paiement-non-aff/paiement-non-aff.component';
import { DepuisAvoirComponent } from './Vente/facture/paiement-facture/depuis-avoir/depuis-avoir.component';
import { BanqueComponent } from './comptabilite/banque/banque.component';
import { DetailBanqueComponent } from './comptabilite/banque/detail-banque/detail-banque.component';
import { ChequeTraitesComponent } from './comptabilite/cheque-traites/cheque-traites.component';
import { AddChequeComponent } from './comptabilite/cheque-traites/add-cheque/add-cheque.component';
import { BrouillonTransfComponent } from './stock/bon-transfert/bontransfert-table/brouillon-transf/brouillon-transf.component';
import { CreateTransfComponent } from './stock/bon-transfert/bontransfert-table/create-transf/create-transf.component';
import { LoadngTransfComponent } from './stock/bon-transfert/bontransfert-table/loadng-transf/loadng-transf.component';
import { TransfereTransfComponent } from './stock/bon-transfert/bontransfert-table/transfere-transf/transfere-transf.component';
import { AnnuleTransfComponent } from './stock/bon-transfert/bontransfert-table/annule-transf/annule-transf.component';
import { AllTransfComponent } from './stock/bon-transfert/bontransfert-table/all-transf/all-transf.component';
import { AddBonTransfertComponent } from './stock/bon-transfert/add-bon-transfert/add-bon-transfert.component';
import { FiltreDateComponent } from './filtre-date/filtre-date.component';
import { RapportComponent } from './rapport/rapport.component';
import { DetailRapportComponent } from './rapport/detail-rapport/detail-rapport.component';

import { SmsModalComponent } from './Vente/commande-client/sms-modal/sms-modal.component';
import { ApercueComponent } from './shared/apercue/apercue.component';
import { DocumentComponent } from './shared/document/document.component';
import { CmdFournisseurComponent } from './Achat/cmd-fournisseur/cmd-fournisseur.component';

import { TousCmdFournComponent } from './Achat/cmd-fournisseur/Tab/tous-cmd-fourn/tous-cmd-fourn.component';
import { BrouillonCmdFournComponent } from './Achat/cmd-fournisseur/Tab/brouillon-cmd-fourn/brouillon-cmd-fourn.component';
import { ValideCmdFournComponent } from './Achat/cmd-fournisseur/Tab/valide-cmd-fourn/valide-cmd-fourn.component';
import { CreeCmdFournComponent } from './Achat/cmd-fournisseur/Tab/cree-cmd-fourn/cree-cmd-fourn.component';
import { AnnuleCmdFournComponent } from './Achat/cmd-fournisseur/Tab/annule-cmd-fourn/annule-cmd-fourn.component';
import { ApproveCmdFournComponent } from './Achat/cmd-fournisseur/approve-cmd-fourn/approve-cmd-fourn.component';
import { DetailCmdFournissComponent } from './Achat/cmd-fournisseur/detail-cmd-fourniss/detail-cmd-fourniss.component';
import { BonReceptionComponent } from './Achat/bon-reception/bon-reception.component';
import { FactureFournisseurComponent } from './Achat/facture-fournisseur/facture-fournisseur.component';
import { TousBnRecepComponent } from './Achat/bon-reception/TabBonRecep/tous-bn-recep/tous-bn-recep.component';
import { BrouillonBnRecepComponent } from './Achat/bon-reception/TabBonRecep/brouillon-bn-recep/brouillon-bn-recep.component';
import { CreeBnRecepComponent } from './Achat/bon-reception/TabBonRecep/cree-bn-recep/cree-bn-recep.component';
import { AnnuleBnRecepComponent } from './Achat/bon-reception/TabBonRecep/annule-bn-recep/annule-bn-recep.component';
import { RecuBnRecepComponent } from './Achat/bon-reception/TabBonRecep/recu-bn-recep/recu-bn-recep.component';
import { ApproveBnRecepComponent } from './Achat/bon-reception/approve-bn-recep/approve-bn-recep.component';
import { TousFacFComponent } from './Achat/facture-fournisseur/TabFacF/tous-fac-f/tous-fac-f.component';
import { BrouillonFacFComponent } from './Achat/facture-fournisseur/TabFacF/brouillon-fac-f/brouillon-fac-f.component';
import { PayeFacFComponent } from './Achat/facture-fournisseur/TabFacF/paye-fac-f/paye-fac-f.component';
import { NonPayeFacFComponent } from './Achat/facture-fournisseur/TabFacF/non-paye-fac-f/non-paye-fac-f.component';
import { AnnuleFacFComponent } from './Achat/facture-fournisseur/TabFacF/annule-fac-f/annule-fac-f.component';
import { ApproveFacFComponent } from './Achat/facture-fournisseur/approve-fac-f/approve-fac-f.component';
import { AddTaxeComponent } from './gestionProduits/add-product/add-taxe/add-taxe.component';
import { AddFournissComponent } from './shared/add-fourniss/add-fourniss.component';
import { AddClientModalComponent } from './shared/add-client-modal/add-client-modal.component';

import { AddProductModalComponent } from './shared/document/add-product-modal/add-product-modal.component';
import {Ng2FlatpickrModule} from 'ng2-flatpickr';
import {CoreSidebarModule} from '../../../@core/components';
import {FeatherModule} from 'angular-feather';
import { PartiellemenrPayeFactureComponent } from './Vente/facture/tabFacture/partiellemenr-paye-facture/partiellemenr-paye-facture.component';
import { ConsolidationFactureComponent } from './Vente/facture/tabFacture/consolidation-facture/consolidation-facture.component';
import { PartPayeFacFComponent } from './Achat/facture-fournisseur/TabFacF/part-paye-fac-f/part-paye-fac-f.component';
import { CroudComponent } from '../parametre/liste-prix/croud-liste-prix/croud.component';
import { CompteBancaireComponent } from '../parametre/compte-bancaire/compte-bancaire.component';
import { AjoutProjetComponent } from '../parametre/project-parametre/ajout-projet/ajout-projet.component';
import { DetailInventaireComponent } from './stock/inventaire/detail-inventaire/detail-inventaire.component';
import { ArticleCmdFournissComponent } from './Achat/cmd-fournisseur/detail-cmd-fourniss/article-cmd-fourniss/article-cmd-fourniss.component';
import { DocumentCmdFournissComponent } from './Achat/cmd-fournisseur/detail-cmd-fourniss/document-cmd-fourniss/document-cmd-fourniss.component';
import { CroudCompteBancaireComponent } from '../parametre/compte-bancaire/croud-compte-bancaire/croud-compte-bancaire.component';
import { RetourFournisseurComponent } from './Achat/retour-fournisseur/retour-fournisseur.component';
import { TousRetourFrnsComponent } from './Achat/retour-fournisseur/Tab-retourFrns/tous-retour-frns/tous-retour-frns.component';
import { BrouillonRetourFrnsComponent } from './Achat/retour-fournisseur/Tab-retourFrns/brouillon-retour-frns/brouillon-retour-frns.component';
import { FactureConsolidComponent } from './POS/facture-consolid/facture-consolid.component';
import { FactureClientComponent } from './POS/facture-client/facture-client.component';
import {TicketCaisseComponent} from "./POS/ticket-caisse/ticket-caisse.component";
import { DisponibleTicketCaisseComponent } from './POS/ticket-caisse/tabTicketCaisse/disponible-ticket-caisse/disponible-ticket-caisse.component';
import { ConsolideTicketCaisseComponent } from './POS/ticket-caisse/tabTicketCaisse/consolide-ticket-caisse/consolide-ticket-caisse.component';
import { FactureCltTicketCaisseComponent } from './POS/ticket-caisse/tabTicketCaisse/facture-clt-ticket-caisse/facture-clt-ticket-caisse.component';
import { AvoireTicketCaisseComponent } from './POS/ticket-caisse/tabTicketCaisse/avoire-ticket-caisse/avoire-ticket-caisse.component';
import { AnnuleTicketCaisseComponent } from './POS/ticket-caisse/tabTicketCaisse/annule-ticket-caisse/annule-ticket-caisse.component';
import { TousTicketCaisseComponent } from './POS/ticket-caisse/tabTicketCaisse/tous-ticket-caisse/tous-ticket-caisse.component';
import { TickeTicketCaisseComponent } from './POS/ticket-caisse/tabTicketCaisse/ticke-ticket-caisse/ticke-ticket-caisse.component';
import { AnnulerMultiTicketModalComponent } from './POS/annuler-multi-ticket-modal/annuler-multi-ticket-modal.component';
import { FacturerMultiTicketModalComponent } from './POS/facturer-multi-ticket-modal/facturer-multi-ticket-modal.component';
import { DetailleMultiSelectionTicketComponent } from './POS/detaille-multi-selection-ticket/detaille-multi-selection-ticket.component';
import { LogicielCaisseFactureDetailComponent } from './POS/logiciel-caisse-facture-detail/logiciel-caisse-facture-detail.component';
import { AccesLogicielCaisseShellComponent } from './POS/acces-logiciel-caisse/acces-logiciel-caisse-shell.component';
import { AccesLogicielCaisseAddShellComponent } from './POS/acces-logiciel-caisse/acces-logiciel-caisse-add-shell.component';
import { AccesLogicielCaisseListComponent } from './POS/acces-logiciel-caisse/acces-logiciel-caisse-list.component';
import { AccesLogicielCaisseOnboardingComponent } from './POS/acces-logiciel-caisse/acces-logiciel-caisse-onboarding.component';
import { AccesLogicielCaisseAddComponent } from './POS/acces-logiciel-caisse/acces-logiciel-caisse-add.component';
import { AccesLogicielCaisseConnexionComponent } from './POS/acces-logiciel-caisse/acces-logiciel-caisse-connexion.component';
import { POSContentComponent } from './POS/poscontent/poscontent.component';
import { ConvertTickCaissComponent } from './POS/convert-tick-caiss/convert-tick-caiss.component';
import { LogicielCaisseGestionStockComponent } from './logiciel-caisse/gestion-stock/logiciel-caisse-gestion-stock.component';
import { LogicielCaisseGestionStockTabComponent } from './logiciel-caisse/gestion-stock/logiciel-caisse-gestion-stock-tab.component';
import { LogicielCaisseGestionStockContentComponent } from './logiciel-caisse/gestion-stock/logiciel-caisse-gestion-stock-content.component';
import { LogicielCaisseStockToolbarComponent } from './logiciel-caisse/shared/logiciel-caisse-stock-toolbar/logiciel-caisse-stock-toolbar.component';
import { LogicielCaissePosPaginationComponent } from './logiciel-caisse/shared/logiciel-caisse-pos-pagination/logiciel-caisse-pos-pagination.component';
import { LcTableShellComponent } from './logiciel-caisse/shared/lc-table-shell/lc-table-shell.component';
import { LcTableSkeletonComponent } from './logiciel-caisse/shared/lc-table-skeleton/lc-table-skeleton.component';
import { LcRouteOutletComponent } from './logiciel-caisse/shared/lc-route-outlet/lc-route-outlet.component';
@NgModule({
    declarations: [
        DashboardComponent,
        ProductsComponent,
        AddProductComponent,
        ActiveProductsComponent,
        ArchivesProductsComponent,
        ProductTableComponent,
        ProductDetailShellComponent,
        AddProductShellComponent,
        ProductsListShellComponent,
        ClientsListShellComponent,
        AddClientShellComponent,
        ClientDetailShellComponent,
        FournisseurDetailShellComponent,
        LayoutStepsComponent,
        EditProductComponent,
        AddClientComponent,
        DetailsComponent,
        DetailsChiffreAffComponent,
        DetailsContenueComponent,
        DetailsFacturesComponent,
        DetailsProfilComponent,
        DetailsContenueApercueComponent,
        DetailsContenueDocumentComponent,
        DetailsContenuePaiementNonAffComponent,
        DetailsContenueReleveCompteComponent,
        DocumentBonDeLivraisonComponent,
        DocumentBonDeSoriteComponent,
        DocumentCommandeClientComponent,
        DocumentDevisComponent,
        DocumentFactureComponent,
        FournisseursListShellComponent,
        AddFournisseurShellComponent,
        AddFournisseurComponent,
        LayoutStepFournissComponent,
        DetailsFournissComponent,
        FournissDetailChiffreAffComponent,
        FournissDetailChiffreContenueComponent,
        FournissDetailContenueComponent,
        FournissDetailProfilComponent,
        FournissDetailChiffreFactureComponent,
        FrDetailContenuApercueComponent,
        FrDetailContenuDocumentComponent,
        FrDetailContenuPaiementNonAffComponent,
        FrDetailContenuReleveCompteComponent,
        FrDocBonRecepComponent,
        FrDocFactureComponent,
        FrDocCommandeComponent,
        GestionStockComponent,
        EtatStockComponent,
        ApercuComponent,
        EtatTableComponent,
        EditWarehouseComponent,
        ResetStockComponent,
        InventaireComponent,
        AddInventaireComponent,
        ApprovedInventaireComponent,
        DevisComponent,
      //  ApproveVenteComponent,
        AllInvComponent,
        ValideInvComponent,
        CreateInvComponent,
        CancelInvComponent,
        BroullionInvComponent,
        InventaireTableComponent,
        BonTransfertComponent,
        BrouillonDevisComponent,
        TousDevisComponent,
        CreeDevisComponent,
        AnnulerDevisComponent,
        NegociationDevisComponent,
        AccepterDevisComponent,
        TresorerieComponent,
        DetailTresorerieComponent,
        SaveComponent,
        AddDepenseComponent,
        AjoutSoldeComponent,
        RemiseBanqueComponent,
        CommandeClientComponent,
        TabCmdClientComponent,
        // ConvertCmdComponent,
        ApproveCmdComponent,
        TousCmdComponent,
        BrouillonCmdComponent,
        AnnuleCmdComponent,
        CreeCmdComponent,
        ValideCmdComponent,
        FactureComponent,
        BonLivraisonComponent,
        BonSortieComponent,
        TousBonLivComponent,
        BrouillonBonLivComponent,
        CreeBonLivComponent,
        AnnuleBonLivComponent,
        LivreBonLivComponent,
        ApproveBarBonLivComponent,
        TousFactureComponent,
        BrouillonFactureComponent,
        PayeFactureComponent,
        AnnuleFactureComponent,
        NonPayeFactureComponent,
        PartiellemenrPayeFactureComponent,
        ApproveFactureComponent,
        ApproveBonSortieComponent,
        TousBonSortieComponent,
        BrouillonBonSortieComponent,
        CreeBonSortieComponent,
        AnnuleBonSortieComponent,
        FermeBonSortieComponent,
        BanqueComponent,
        DetailBanqueComponent,
        ChequeTraitesComponent,
        AddChequeComponent,
        BrouillonTransfComponent,
        CreateTransfComponent,
        LoadngTransfComponent,
        TransfereTransfComponent,
        AnnuleTransfComponent,
        AllTransfComponent,
        AddBonTransfertComponent,
        FiltreDateComponent,
        DocumentComponent,
        SharedComponent,
        DocumentListProgressComponent,
        TabCountComponent,
        TablePaginationBarComponent,
        TitleSectionComponent,
        ParametreBarComponent,
        EmailComposeComponent,
        FileUploadModalComponent,
        ImportQRComponent,
        CmdFournisseurComponent,
        TousCmdFournComponent,
        BrouillonCmdFournComponent,
        ValideCmdFournComponent,
        CreeCmdFournComponent,
        AnnuleCmdFournComponent,
        ApproveCmdFournComponent,
        BonReceptionComponent,
        FactureFournisseurComponent,
        TousBnRecepComponent,
        BrouillonBnRecepComponent,
        CreeBnRecepComponent,
        AnnuleBnRecepComponent,
        RecuBnRecepComponent,
        ApproveBnRecepComponent,
        TousFacFComponent,
        BrouillonFacFComponent,
        PayeFacFComponent,
        NonPayeFacFComponent,
        AnnuleFacFComponent,
        ApproveFacFComponent,



        RapportComponent,
        DetailRapportComponent,
        AddTaxeComponent,
        AddFournissComponent,
        AddClientModalComponent,
        AddProductModalComponent,
        ConsolidationFactureComponent,
        PartPayeFacFComponent,
        CroudComponent,
        CompteBancaireComponent,
        AjoutProjetComponent,
        DetailVenteComponent,
        ConvertModalComponent,
        PaiementFactureComponent,
        NouveauPaiementComponent,
        PaiementNonAffComponent,
        DepuisAvoirComponent,
        SmsModalComponent,
        DetailCmdFournissComponent,
        ArticleCmdFournissComponent,
        DocumentCmdFournissComponent,
        DetailInventaireComponent,
        CroudCompteBancaireComponent,
        TicketCaisseComponent,
        RetourFournisseurComponent,
        TousRetourFrnsComponent,
        BrouillonRetourFrnsComponent,
        FactureConsolidComponent,
        FactureClientComponent,
        DisponibleTicketCaisseComponent,
        ConsolideTicketCaisseComponent,
        FactureCltTicketCaisseComponent,
        AvoireTicketCaisseComponent,
        AnnuleTicketCaisseComponent,
        TousTicketCaisseComponent,
        TickeTicketCaisseComponent,
        AnnulerMultiTicketModalComponent,
        FacturerMultiTicketModalComponent,
        LogicielCaisseFactureDetailComponent,
        AccesLogicielCaisseShellComponent,
        AccesLogicielCaisseAddShellComponent,
        AccesLogicielCaisseListComponent,
        AccesLogicielCaisseOnboardingComponent,
        AccesLogicielCaisseAddComponent,
        AccesLogicielCaisseConnexionComponent,
        DetailleMultiSelectionTicketComponent,
        POSContentComponent,
        ConvertTickCaissComponent,
        LogicielCaisseGestionStockComponent,
        LogicielCaisseGestionStockTabComponent,
        LogicielCaisseGestionStockContentComponent,
        LogicielCaisseStockToolbarComponent,
        LogicielCaissePosPaginationComponent,
        LcTableShellComponent,
        LcTableSkeletonComponent,
        LcRouteOutletComponent,
        ApproveBarBonLivNegoceComponent,
        BonLivraisonNegoceComponent,
        AnnuleBonLivNegoceComponent,
        BrouillonBonLivNegoceComponent,
        CreeBonLivNegoceComponent,
        LivreBonLivNegoceComponent,
        TousBonLivNegoceComponent,
        ApproveBonSortieNegoceComponent,
        BonSortieNegoceComponent,
        AnnuleBonSortieNegoceComponent,
        BrouillonBonSortieNegoceComponent,
        CreeBonSortieNegoceComponent,
        FermeBonSortieNegoceComponent,
        TousBonSortieNegoceComponent,
        ApproveCmdNegoceComponent,
        CommandeClientNegoceComponent,
        SmsModalNegoceComponent,
        TabCmdClientNegoceComponent,
        AnnuleCmdNegoceComponent,
        BrouillonCmdNegoceComponent,
        CreeCmdNegoceComponent,
        TousCmdNegoceComponent,
        ValideCmdNegoceComponent,
        AccepterDevisNegoceComponent,
        AnnulerDevisNegoceComponent,
        BrouillonDevisNegoceComponent,
        CreeDevisNegoceComponent,
        NegociationDevisNegoceComponent,
        TousDevisNegoceComponent,
        ConvertModalNegoceComponent,
        DevisNegoceComponent,
        DetailVenteNegoceComponent,
        EmailComposeNegoceComponent,
        FileUploadModalNegoceComponent,
        ImportQRNegoceComponent,
        ParametreBarNegoceComponent,

    ],
    imports: [
        CommonModule,
        CoreCommonModule,
        ContentHeaderModule,
        NgbModule,
        NgSelectModule,
        FormsModule,
        AuthenticationModule,
        MiscellaneousModule,
        NavbarModule,
        RouterModule,
        NgxPaginationModule,
        Ng2FlatpickrModule,
        NgChartsModule,
        NgSelectModule,
        CoreSidebarModule,
        FeatherModule,
        LayoutStepsClientModule,

    ],
    exports: [
        FiltreDateComponent,
        SharedComponent,
        TablePaginationBarComponent,
        TitleSectionComponent,
        ProductDetailShellComponent,
        AddProductShellComponent,
        ProductsListShellComponent,
        ClientsListShellComponent,
        AddClientShellComponent,
        ClientDetailShellComponent,
        FournisseurDetailShellComponent,
        FournisseursListShellComponent,
        AddFournisseurShellComponent,
        ParametreBarComponent,
        DetailVenteComponent,
        DetailInventaireComponent,
        CompteBancaireComponent,
        DetailCmdFournissComponent,
        CroudComponent,
        AjoutProjetComponent,
        LayoutStepsClientModule,
        AccesLogicielCaisseShellComponent,
        AccesLogicielCaisseAddShellComponent,
        AccesLogicielCaisseListComponent,
        AccesLogicielCaisseOnboardingComponent,
        AccesLogicielCaisseAddComponent,
        AccesLogicielCaisseConnexionComponent,
        TicketCaisseComponent,
        TousTicketCaisseComponent,
        TickeTicketCaisseComponent,
        DisponibleTicketCaisseComponent,
        ConsolideTicketCaisseComponent,
        AvoireTicketCaisseComponent,
        AnnuleTicketCaisseComponent,
        LogicielCaisseFactureDetailComponent,
        LogicielCaisseGestionStockComponent,
        LogicielCaisseGestionStockTabComponent,
        LogicielCaisseGestionStockContentComponent,
    ],


    providers: []
})
export class PagesModule {}
